module.exports = require('./brand-express-middleware');